import { createRoute } from '@tanstack/react-router'
import { projectRoute } from '../route'
import { redirectLegacyProjectSettings } from '@/components/settings/legacy-redirects'

/** Old settings pages → the settings dialog (board h39z). */
export const projectSettingsRoute = createRoute({
  getParentRoute: () => projectRoute,
  path: '/settings/$',
  beforeLoad: redirectLegacyProjectSettings,
  component: () => null,
})
